import { useUnit } from 'effector-react';
import { $additionalProducts } from 'models/additional-products';

import AdditionalProducts from './AdditionalProducts';

import AdvisorLogo from 'components/pages/Dashboard/common/AdvisorLogo';
import EpActionsBlock from 'components/pages/Dashboard/common/EpActionsBlock';
import EpProgress from 'components/pages/Dashboard/common/EpProgress';
import LearnCenter from 'components/pages/Dashboard/common/LearnCenter';
import OrigSpouseTabs from 'components/pages/Dashboard/common/OrigSpouseTabs';
import PlanTitle from 'components/pages/Dashboard/common/PlanTitle';
import YourResources from 'components/pages/Dashboard/common/YourResources';
import Cards from 'components/pages/Dashboard/complete/Cards';
import 'components/pages/Dashboard/complete/CompletePage.scss';
import DiagramsViewerModal from 'components/pages/Dashboard/complete/DiagramsViewerModal';
import RemainingStepsTabs from 'components/pages/Dashboard/complete/RemainingStepsTabs';

import { EXECUTION_STEPS_PROGRESS_PERCENT, QUESTIONS_PROGRESS_PERCENT } from 'constants/dashboard';

import useExecutionSteps from 'hooks/useExecutionSteps';
import useResources from 'hooks/useResources';

import { type AdditionalProductNames } from 'types/zod/additional-products';

const CompletePage = () => {
    const { allDone: remainingStepsAreDone, steps } = useExecutionSteps();

    const { t } = useResources();

    const numberOfCompleteSteps = steps.filter((step) => step.done).length;
    const stepsProgress = numberOfCompleteSteps / steps.length;
    const progress = QUESTIONS_PROGRESS_PERCENT + EXECUTION_STEPS_PROGRESS_PERCENT * stepsProgress;

    const additionalProducts = useUnit($additionalProducts);
    const visibleAdditionalProducts = Object.entries(additionalProducts)
        .filter(([, value]) => value)
        .map(([key]) => key as AdditionalProductNames);

    return (
        <div className="complete-page">
            <DiagramsViewerModal />
            <div className="mb-4">
                <div className="d-flex gap-4 align-items-center">
                    {!remainingStepsAreDone && <EpProgress progress={progress} />}
                    <div className="flex-grow-1 pl-4 pl-sm-0">
                        <PlanTitle />
                    </div>
                    <div className="d-none d-sm-block">
                        <AdvisorLogo />
                    </div>
                </div>
                {remainingStepsAreDone && <OrigSpouseTabs />}
            </div>
            {remainingStepsAreDone && <Cards />}
            {!remainingStepsAreDone && (
                <>
                    <div className="finalize-plan mb-3">
                        <div className="finalize-plan-header">
                            {t('newDashboardPage.completePage.finalizeYourPlan')}
                        </div>
                        <EpActionsBlock updateText={t('newDashboardPage.completePage.updatePlan')} />
                    </div>
                    <RemainingStepsTabs />
                </>
            )}
            {visibleAdditionalProducts.length > 0 && (
                <div className="mt-5">
                    <AdditionalProducts />
                </div>
            )}
            <div className="mt-5">
                <YourResources />
            </div>

            <div className="mt-5 mb-5">
                <LearnCenter articles={t(`newDashboardPage.learnCenter.articles`, { returnObjects: true })} />
            </div>
        </div>
    );
};

export default CompletePage;
